import React from 'react';
import callCenter from "../../assets/img/call-center-support.svg";

const SupportSection = () => {
    return (
        <section className="ptb-60 primary-bg">
            <div className="container">
                <div className="row align-items-center justify-content-between">
                    <div className="col-12 col-lg-6">
                        <div className="cta-content-wrap text-white">
                            <h2 className="text-white">
                                24/7 Expert Hosting Support Our Customers Love
                            </h2>
                            <p>
                                Objectively innovate high compellingly maintain progressively pursue
                                mission-critical information quality imperatives.
                            </p>
                        </div>
                        <div className="support-action d-inline-flex flex-wrap">
                            <a href="mailto:support@yourdomain.com" className="me-3 text-info">
                                <i className="fas fa-comment me-1 text-tertiary"></i>
                                <span>support@yourdomain.com</span>
                            </a>
                            <a href="tel:+00123456789" className="mb-0 text-info">
                                <i className="fas fa-phone-alt me-1 text-tertiary"></i>
                                <span>+00123456789</span>
                            </a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 d-none d-lg-block">
                        <div className="cta-img-wrap text-center">
                            <img src={callCenter} width="250" className="img-fluid" alt="call center support"/>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SupportSection;
